// extracted by mini-css-extract-plugin
module.exports = {"container":"video_container___W-4R","video":"video_video__3PTP2","videoPlayer":"video_videoPlayer__2olEY"};